import { render } from "./report-general.vue?vue&type=template&id=35ca7b97"
import script from "./report-general.js?vue&type=script&lang=js&external"
export * from "./report-general.js?vue&type=script&lang=js&external"

import "./report-general.vue?vue&type=style&index=0&id=35ca7b97&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__